import React, { useContext, useCallback, useState,useEffect } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { ModalNextProvider, Loader } from '@jutro/components';
import { readViewModelValue } from 'gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from 'gw-portals-viewmodel-react';
import { useValidation } from 'gw-portals-validation-react';
import { JobUtil } from 'gw-portals-util-js';
import { SubmissionService, OrganizationService } from 'gw-capability-gateway';
import { AccountService } from 'gw-capability-gateway-policy';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import metadata from './NewSubmissionPage.metadata.json5';
import styles from './NewSubmissionPage.module.scss';
import messages from '../../NewQuoteAccountSearch.messages';
import gatewayMessages from '../../../gateway.messages';
import PortalUtil from '../../../../../utils/PortalUtil';
import { TranslatorContext, IntlContext } from '@jutro/locale';

function NewSubmissionPage(props) {
    const viewModelService = useContext(ViewModelServiceContext);
    const {
        isAnExistingAccount,
        submissionVM,
        postalCode,
        updateSubmissionVM,
        producerCodeValue,
        isAgent,
        allOrganisationValue,
        authHeader
    } = props;
    const [productValue, updateProductValue] = useState([]);
    const [producerCodeOrgValue, updateProducerCodeValue] = useState([]);
    const [selectedOrganisationValue, updateOrganisation] = useState('');
    const [showErrors, updateShowErrors] = useState([false]);
    const { history } = props;
    const { lobQuoteURL } = appConfig;
    const { onValidate, isComponentValid } = useValidation('NewSubmissionPage');
    const [isLoading, setIsLoading] = useState(false);
    const {dateUtil} = PortalUtil;
    const translator = useContext(TranslatorContext);
    const intl = useContext(IntlContext);

    useEffect( () => {
        if(isAnExistingAccount && producerCodeOrgValue.length == 0 ) {

            const accProducerCodes = [] ;
            _.each(producerCodeValue, (producerCode) => {
                accProducerCodes.push({code : producerCode.code,name :  producerCode.displayValue,
                });
            });
            const acOrginization = {
                code: producerCodeValue[0].organizationDTO.publicID,
                name: producerCodeValue[0].organizationDTO.displayName
            };
            updateOrganisation(acOrginization.code);
            const newSubmissionVMClone = viewModelService.clone(submissionVM);
            _.set(newSubmissionVMClone, 'producerCode.value',  producerCodeValue[0].code);
            if(productValue.length == 0) {
                refreshProducts(newSubmissionVMClone);
            }
            updateSubmissionVM(newSubmissionVMClone)
            updateProducerCodeValue(accProducerCodes);
        }

    },[submissionVM,producerCodeValue,allOrganisationValue,isAnExistingAccount])

    const startSubmission = useCallback(async () => {

        setIsLoading(true);
        const productCode = _.get(submissionVM, 'productCode.value');
        const SubmissionResponse = await SubmissionService.createSubmission(
            submissionVM.value,
            authHeader
        );
        setIsLoading(false);
        const newSubmissionResponse = SubmissionResponse;
        if (newSubmissionResponse.jobNumber > 0) {
            if (!_.isNil(lobQuoteURL[productCode])) {
                const nextLocation = {
                    quoteentry: {
                        postalCode: postalCode,
                        quoteID: newSubmissionResponse.jobNumber,
                        isNewSubmission: true
                    }
                };
                history.push(lobQuoteURL[productCode], nextLocation);
            } else {
                JobUtil.openJobInXCenter(newSubmissionResponse.jobNumber);
            }
        }
    }, [authHeader, history, lobQuoteURL, postalCode, submissionVM]);
    const refreshProducts = useCallback(
        async (newSubmissionVM) => {
            try {
                const submission = {
                    ...newSubmissionVM.value,
                    // product code is a required field and must have a value
                    productCode: _.get(newSubmissionVM, 'productCode.value', '')
                };
                const productCodeResponse = await AccountService.getAvailableProductsForAccount(
                    submission,
                    authHeader
                );
                const productCodeValues = productCodeResponse;
                const productCodeAvailableValue = productCodeValues
                    .filter((value) => !value.isRiskReserved)
                    .map(({ productCode, productName }) => {
                        return {
                            code: productCode,
                            name: productName
                        };
                    });
                updateProductValue(productCodeAvailableValue);
            } catch {
                updateProductValue([]);
                ModalNextProvider.showAlert({
                    title: gatewayMessages.modalError,
                    message: gatewayMessages.gatewayViewsModalErrorData,
                    status: 'error',
                    icon: 'mi-error-outline'
                }).catch(_.noop);
            }
        },
        [authHeader]
    );

    const getProducerCodesOrganization = useCallback(
        async (organisationCode) => {
            const producerCodeResponse = await OrganizationService.getProducerCodeForOrganization(
                organisationCode,
                authHeader
            );
            const producerCodeOrganisation = producerCodeResponse.map((value) => {
                return {
                    code: value.code,
                    name: value.displayValue
                };
            });
            updateProducerCodeValue(producerCodeOrganisation);
            _.set(submissionVM, 'producerCode', '');
            _.set(submissionVM, 'productCode', '');
            updateSubmissionVM(submissionVM);
        },
        [authHeader, submissionVM, updateSubmissionVM]
    );
    const handleValueOrganisation = (value) => {
        let organisationCode = {};

        const selectedOrganisation = value;
        allOrganisationValue.forEach((result) => {
            if (result.code === selectedOrganisation) {
                organisationCode = {
                    displayName: result.name,
                    publicID: result.code
                };
            }
        });
        getProducerCodesOrganization(organisationCode);
        updateOrganisation(value);
    };
    const writeValue = useCallback(
        (value, path) => {
            const newSubmissionVMClone = viewModelService.clone(submissionVM);
            _.set(newSubmissionVMClone, path, value);
            updateSubmissionVM(newSubmissionVMClone);
            if (
                (path === 'producerCode' || path === 'effectiveDate' || path === 'state')
                && !!(
                    _.get(newSubmissionVMClone, 'producerCode.value')
                    && _.get(newSubmissionVMClone, 'state.value.code')
                    && _.get(newSubmissionVMClone, 'effectiveDate.value')
                )
            ) {
                refreshProducts(newSubmissionVMClone);
                _.set(newSubmissionVMClone, 'productCode', '');
                updateSubmissionVM(newSubmissionVMClone);
            }
        },
        [refreshProducts, submissionVM, updateSubmissionVM, viewModelService]
    );
    const handleCancel = useCallback(() => {
        const accountNumber = _.get(submissionVM, 'accountNumber.value');
        ModalNextProvider.showConfirm({
            title: messages.cancelQuote,
            message: messages.cancelMessage,
            status: 'warning',
            icon: 'mi-error-outline'
        }).then((results) => {
            if (results === 'cancel') {
                return _.noop();
            }
            if (accountNumber) {
                history.push(`/accounts/${accountNumber}/summary`);
            } else {
                history.push('/');
            }
            return true;
        }, _.noop);
    }, [history, submissionVM]);
    const handleValidation = useCallback(() => {
        updateShowErrors(true);
    }, [updateShowErrors]);
    const producerdisable = producerCodeOrgValue.length > 0
        ? isAgent : producerCodeOrgValue.length === 0;
    const isAgentProducer = !isAgent ? producerdisable : !isAnExistingAccount;
    const minDate = new Date();
    const newMinEffectiveDate = dateUtil.addDaysToLocalDate(dateUtil.toLocalDate(minDate), - 30)
    const startDate = dateUtil.toDate(_.get(submissionVM,'effectiveDate.value'));
    const newMinEffectiveDateobj = dateUtil.toDate(newMinEffectiveDate);
    const overrideProps = {
        '@field': {
            labelPosition: 'left',
            showOptional: false,
            showRequired: true
        },
        newSubmissionContainer: {
            visible: isAnExistingAccount
        },
        buttoncontainer: {
            visible: isAnExistingAccount
        },
        submissionProducerCode: {
            availableValues: producerCodeOrgValue,
                // _.isArray(producerCodeValue) && producerCodeValue.length > 0
                //     ? producerCodeValue
                //     : producerCodeOrgValue,
            disabled: isAgentProducer
        },
        submissionState: {
            disabled: !isAnExistingAccount
        },
        submissionProductCode: {
            availableValues: productValue,
            // disabled: !_.get(submissionVM, 'producerCode.value')
        },
        submissionOrganisation: {
            visible: !isAgent,
            availableValues: allOrganisationValue,
            onValueChange: handleValueOrganisation,
            value: selectedOrganisationValue
        },
        cancel: {
            disabled: !isAnExistingAccount
        },
        next: {
            disabled: !isAnExistingAccount
        },
        //  submissionDate: {
        //      minDate: newMinEffectiveDate,
        //      showErrors: startDate < newMinEffectiveDateobj,
        //      validationMessages: startDate < newMinEffectiveDateobj ? [`${translator(gatewayMessages.effectiveDateError)} ${intl.formatDate(newMinEffectiveDateobj, { year: 'numeric', month: 'short', day: 'numeric' })}`] : [],
        // }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            startSubmission: isComponentValid ? startSubmission : handleValidation,
            onCancel: handleCancel
        }
    };
    const readValue = (id, path) => {
        return readViewModelValue(metadata.pageContent, submissionVM, id, path, overrideProps);
    };

    if (isLoading) {
        return <Loader loaded={!isLoading} />;
    }

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={submissionVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValidationChange={onValidate}
            onValueChange={writeValue}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
            showErrors={showErrors}
        />
    );
}
NewSubmissionPage.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func
    }).isRequired,
    isAnExistingAccount: PropTypes.bool,
    submissionVM: PropTypes.shape({
        value: PropTypes.shape({})
    }),
    allOrganisationValue: PropTypes.arrayOf(PropTypes.object),
    postalCode: PropTypes.string,
    updateSubmissionVM: PropTypes.func,
    producerCodeValue: PropTypes.arrayOf(PropTypes.string),
    isAgent: PropTypes.string,
    authHeader: PropTypes.shape({})
};

NewSubmissionPage.defaultProps = {
    isAnExistingAccount: false,
    submissionVM: {},
    allOrganisationValue: [],
    postalCode: '',
    updateSubmissionVM: undefined,
    producerCodeValue: [],
    isAgent: false,
    authHeader: {}
};
export default withRouter(NewSubmissionPage);
